import { render } from "./Classification.vue?vue&type=template&id=93f08326&scoped=true&ts=true"
import script from "./Classification.vue?vue&type=script&lang=ts"
export * from "./Classification.vue?vue&type=script&lang=ts"

import "./Classification.vue?vue&type=style&index=0&id=93f08326&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f08326"]])

export default __exports__